export default "__VITE_ASSET__IsRV0FwR__"